import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const YouTubeLabelIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox='0 0 24 24'>
        <path d="M22.54 6.39c-.25-.94-1-1.68-1.95-1.93C18.88 4 12 4 12 4s-6.88 0-8.6.46c-.94.25-1.69.99-1.94 1.93C1 8.09 1 11.65 1 11.65s0 3.56.46 5.26c.25.95 1 1.69 1.94 1.94 1.72.45 8.6.45 8.6.45s6.88 0 8.6-.45c.94-.25 1.69-1 1.94-1.94.46-1.7.46-5.26.46-5.26s0-3.56-.46-5.26Z" fill="red"/><path d="m9.8 14.93 5.71-3.28L9.8 8.37v6.56Z" fill="#fff"/>
    </SvgIcon>
);
